import styled from 'styled-components';

export const TitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 32px;

  p:first-child {
    font-size: 1.75rem;
    font-weight: 500;
    margin-bottom: 0;

    span {
      text-transform: uppercase;
    }
  }

  p:last-child {
    font-size: 1.25rem;
  }

  @media screen and (min-width: 768px) {
    margin-bottom: 48px;

    p:first-child {
      font-size: 1.875rem;
    }

    p:last-child {
      font-size: 1.375rem;
    }
  }
`;

export const FormWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 24px;
  row-gap: 24px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Content = styled.div`
  background-color: ${({theme}) => theme.colors.bg_gray_light};
  padding: 16px;
  height: 100%;
`;

export const SectionLabel = styled.span`
  display: block;
  font-size: 16px;
  font-weight: bold;
  margin: 0 16px;
`;